module.exports = __webpack_public_path__ + "img/iamcham.6d1f438f.webp";